import artifact from '$houdini/artifacts/DeleteDashboardReport'
import { MutationStore } from '../runtime/stores/mutation'

export class DeleteDashboardReportStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
